export interface OrgChart {
  id?: number;
  orgChartUuid?: string;
  name: string;
  jsonStructure?: string;
  isActive?: boolean;
}

export interface OrgLevel {
  id?: number;
  orgLevelUuid?: string;
  orgChartUuid?: string;
  name: string;
  levelType?: string;
  parentOrgLevelUuid?: string | null;
  metadata?: string;
}

export interface OrgLevelNode {
  orgLevelUuid: string;
  name: string;
  levelType?: string;
  parentOrgLevelUuid?: string | null;
  userCount?: number;
  children?: OrgLevelNode[];
}

export interface UserOrgAssignment {
  id?: number;
  userUuid: string;
  orgLevelUuid: string;
  roleInLevel?: string;
  chartUuid?: string;
  chartName?: string;
  levelName?: string;
}

export interface OrgAssignmentRequest {
  orgLevelUuid: string;
  roleInLevel?: string;
  remove?: boolean;
}

export interface OrgPosition {
  assignment: UserOrgAssignment;
  chartUuid: string;
  chartName: string;
  levelUuid: string;
  levelName: string;
}

export interface RepInfo {
  userUuid: string;
  firstName: string;
  lastName: string;
}

export const LEVEL_TYPES = [
  { value: 'sales_manager_pm', label: 'Sales Manager / PM' },
  { value: 'district_manager', label: 'District Manager' },
  { value: 'team_manager', label: 'Team Manager' },
  { value: 'representative', label: 'Representative' },
];
